import {ReactNode, useCallback, useMemo, useState} from 'react';

import {WalkthroughId} from './types';
import {WalkthroughContext} from './WalkthroughContext';

interface Props {
  children: ReactNode;
}

export const WalkthroughProvider = ({children}: Props) => {
  const [pendingRestartId, setPendingRestartId] = useState<WalkthroughId | null>(null);

  const requestRestart = useCallback((id: WalkthroughId) => {
    setPendingRestartId(id);
  }, []);

  const consumeRestart = useCallback((id: WalkthroughId) => {
    setPendingRestartId((current) => (current === id ? null : current));
  }, []);

  const value = useMemo(
    () => ({pendingRestartId, requestRestart, consumeRestart}),
    [pendingRestartId, requestRestart, consumeRestart]
  );

  return <WalkthroughContext.Provider value={value}>{children}</WalkthroughContext.Provider>;
};
